import { render, staticRenderFns } from "./MenuCategorySelect.vue?vue&type=template&id=5afb724c&scoped=true&"
import script from "./MenuCategorySelect.vue?vue&type=script&lang=js&"
export * from "./MenuCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./MenuCategorySelect.vue?vue&type=style&index=0&id=5afb724c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb724c",
  null
  
)

export default component.exports